import { CalendarTodayOutlined } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

export const StyledCalendarTodayOutlined = styled(CalendarTodayOutlined)(({ theme }) => ({
  color: `${theme.palette.action.active} !important`,
}));
